module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "workflow-update update-form row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "row gutter-lg"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4"
  }, [_vm._v("\n        Status: " + _vm._s(_vm.item.status) + "\n        "), _c('hr'), _vm._v(" "), _c('form', {
    staticClass: "workflow-update--form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.update($event)
      }
    }
  }, [_c('field', {
    attrs: {
      "errors": _vm.errors,
      "name": "name",
      "label": "models.workflow.name",
      "placeholder": "My Workflow"
    },
    model: {
      value: (_vm.item.name),
      callback: function($$v) {
        _vm.$set(_vm.item, "name", $$v)
      },
      expression: "item.name"
    }
  }), _vm._v(" "), _c('field', {
    attrs: {
      "required": true,
      "name": "scope",
      "type": "radio",
      "model": "workflow",
      "collection": _vm.workflowScopes
    },
    model: {
      value: (_vm.workflowScope),
      callback: function($$v) {
        _vm.workflowScope = $$v
      },
      expression: "workflowScope"
    }
  }), _vm._v(" "), (_vm.workflowScope == 'project') ? _c('div', [(_vm.projects.length > 0) ? _c('field', {
    directives: [{
      name: "can",
      rawName: "v-can",
      value: ('projects.list'),
      expression: "'projects.list'"
    }],
    attrs: {
      "required": true,
      "errors": _vm.errors,
      "model": "workflow",
      "name": "project",
      "type": "select",
      "params": {
        no_i18n: true
      },
      "collection": _vm.projects
    },
    model: {
      value: (_vm.item.project_id),
      callback: function($$v) {
        _vm.$set(_vm.item, "project_id", $$v)
      },
      expression: "item.project_id"
    }
  }) : _c('p', [_c('i', [_vm._v(_vm._s(_vm.$t('models.workflow.loading_projects')))])])], 1) : _vm._e(), _vm._v(" "), _c('field', {
    attrs: {
      "required": true,
      "errors": _vm.errors,
      "model": "workflow",
      "name": "frequency",
      "type": "select",
      "collection": _vm.frequencies
    },
    model: {
      value: (_vm.item.frequency),
      callback: function($$v) {
        _vm.$set(_vm.item, "frequency", $$v)
      },
      expression: "item.frequency"
    }
  }), _vm._v(" "), (_vm.shouldShowDailyRuntime) ? _c('field', {
    attrs: {
      "required": _vm.shouldShowDailyRuntime,
      "errors": _vm.errors,
      "model": "workflow",
      "name": "daily_runtime",
      "type": "select",
      "collection": _vm.hours,
      "params": {
        no_i18n: true
      }
    },
    model: {
      value: (_vm.item.daily_runtime),
      callback: function($$v) {
        _vm.$set(_vm.item, "daily_runtime", $$v)
      },
      expression: "item.daily_runtime"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "field field-text"
  }, [_c('label', {
    attrs: {
      "for": "first_run"
    }
  }, [_vm._v(_vm._s(_vm.$t('models.workflow.first_run')))]), _vm._v(" "), _c('datetime', {
    staticClass: "text-input",
    attrs: {
      "format": "DD/MM/YYYY H:i:s",
      "id": "first_run"
    },
    model: {
      value: (_vm.firstRun),
      callback: function($$v) {
        _vm.firstRun = $$v
      },
      expression: "firstRun"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "field field-text"
  }, [_c('label', {
    attrs: {
      "for": "final_run"
    }
  }, [_vm._v(_vm._s(_vm.$t('models.workflow.final_run')))]), _vm._v(" "), _c('datetime', {
    staticClass: "text-input",
    attrs: {
      "format": "DD/MM/YYYY H:i:s",
      "id": "final_run"
    },
    model: {
      value: (_vm.finalRun),
      callback: function($$v) {
        _vm.finalRun = $$v
      },
      expression: "finalRun"
    }
  })], 1), _vm._v(" "), _c('field', {
    directives: [{
      name: "can",
      rawName: "v-can",
      value: ('is_root'),
      expression: "'is_root'"
    }],
    attrs: {
      "errors": _vm.errors,
      "model": "workflow",
      "name": "execute_on",
      "type": "textarea",
      "required": true,
      "value": _vm.executeOn
    },
    on: {
      "input": _vm.executeOnChange
    }
  }), _vm._v(" "), _c('field', {
    directives: [{
      name: "can",
      rawName: "v-can",
      value: ('is_root'),
      expression: "'is_root'"
    }],
    attrs: {
      "errors": _vm.errors,
      "model": "workflow",
      "name": "configuration",
      "type": "textarea",
      "required": true,
      "value": _vm.configuration
    },
    on: {
      "input": _vm.configurationChange
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "update-form--actions"
  }, [_c('button', {
    staticClass: "btn btn-tertiary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.cancel($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.global.cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-save",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.global.save')))])])], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d41b8f2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/workflows/WorkflowUpdate.vue
// module id = 1812
// module chunks = 0